import { render } from "react-dom";
import React from "react";
import { TablePagination } from "react-pagination-table";

const Header = ["Name", "Age", "Size", "Phone", "Gender"];

const App = ({ Header, data }) => (
  <div>
    <TablePagination
      title="TablePagination"
      subTitle="Sub Title"
      headers={Header}
      data={data}
      columns="name.age.size.phone.gender"
      perPageItemCount={5}
      totalCount={data.length}
      arrayOption={[["size", "all", " "]]}
    />
  </div>
);
export default App;
